import React, { useEffect } from "react";
import Dmsbanner from "./Dmsbanner";
import Dmsabout from "./Dmsabout";
import Dmsfeatures from "./Dmsfeatures";
import Dmscards from "./Dmscards";
import Webbanner from "./Webbanner";

const Dmspage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
        <Dmsbanner/>
      
      <Dmsabout/>

      <Dmsfeatures/>
      <Dmscards/>
    </div>
  );
};

export default Dmspage;
